import React, { useState } from "react";
import NurseMedicine from "./NurseMedicine";
import NursePharmacyOrders from "../NursePharmacy/NursePharmacyOrders";
import NursePharmacyReturns from "../NursePharmacy/NursePharmacyReturns";
import styles from "./nurseTabs.module.css";

const TABS = [
  { label: "Medications", value: "medications" },
  { label: "Orders", value: "orders" },
  { label: "Order History", value: "history" },
  { label: "Returns", value: "returns" },
];

const NursePharmacyTabs = ({ patientData }) => {
  const [active, setActive] = useState("medications");

  return (
    <div className="nurse-pharmacy-tabs">
      <div className={styles.seg} role="tablist">
        {TABS.map((tab) => (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={active === tab.value}
            className={active === tab.value ? styles.on : undefined}
            onClick={() => setActive(tab.value)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {active === "medications" && <NurseMedicine patientData={patientData} />}

      {active === "orders" && (
        <NursePharmacyOrders
          patientData={patientData}
          view="new"
          onSent={() => setActive("history")}
        />
      )}
      {active === "history" && (
        <NursePharmacyOrders
          patientData={patientData}
          view="history"
        />
      )}

      {active === "returns" && <NursePharmacyReturns patientData={patientData} />}
    </div>
  );
};

export default NursePharmacyTabs;
